// @ts-nocheck
(() => {
  const body = document.body;
  const navToggle = document.querySelector('.nav-toggle');
  const navigation = document.querySelector('#primary-navigation');
  const menuToggles = [...document.querySelectorAll('.nav-menu-toggle')];

  const closeMenu = (toggle, restoreFocus = false) => {
    const menu = document.getElementById(toggle.getAttribute('aria-controls'));
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', toggle.getAttribute('aria-label').replace(/^Close /, 'Open '));
    if (menu) menu.hidden = true;
    if (restoreFocus) toggle.focus();
  };

  const closeAllMenus = (except = null) => {
    menuToggles.forEach((toggle) => {
      if (toggle !== except) closeMenu(toggle);
    });
  };

  menuToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const opening = toggle.getAttribute('aria-expanded') !== 'true';
      closeAllMenus(toggle);
      const menu = document.getElementById(toggle.getAttribute('aria-controls'));
      toggle.setAttribute('aria-expanded', String(opening));
      toggle.setAttribute('aria-label', toggle.getAttribute('aria-label').replace(opening ? /^Open / : /^Close /, opening ? 'Close ' : 'Open '));
      if (menu) menu.hidden = !opening;
    });
  });

  const closeMobileNavigation = (restoreFocus = false) => {
    if (!navToggle) return;
    body.classList.remove('nav-open');
    navToggle.setAttribute('aria-expanded', 'false');
    closeAllMenus();
    if (restoreFocus) navToggle.focus();
  };

  navToggle?.addEventListener('click', () => {
    const opening = navToggle.getAttribute('aria-expanded') !== 'true';
    body.classList.toggle('nav-open', opening);
    navToggle.setAttribute('aria-expanded', String(opening));
    if (!opening) closeAllMenus();
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.nav-group')) closeAllMenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openMenuToggle = menuToggles.find((toggle) => toggle.getAttribute('aria-expanded') === 'true');
    if (openMenuToggle) {
      closeMenu(openMenuToggle, true);
      return;
    }
    if (body.classList.contains('nav-open')) closeMobileNavigation(true);
  });

  navigation?.addEventListener('click', (event) => {
    if (event.target.closest('a') && matchMedia('(max-width: 64rem)').matches) closeMobileNavigation();
  });

  document.querySelectorAll('[data-password-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = document.getElementById(button.getAttribute('aria-controls'));
      if (!input) return;
      const revealing = input.type === 'password';
      input.type = revealing ? 'text' : 'password';
      button.textContent = revealing ? 'Hide' : 'Show';
      button.setAttribute('aria-pressed', String(revealing));
      button.setAttribute('aria-label', `${revealing ? 'Hide' : 'Show'} password`);
    });
  });

  document.querySelectorAll('[data-current-year]').forEach((node) => {
    node.textContent = String(new Date().getFullYear());
  });

  const resumeForm = document.querySelector('[data-registration-resume-form]');
  if (resumeForm) {
    const resumeStatus = resumeForm.closest('.registration-card')?.querySelector('[data-registration-resume-status]');
    const applicationInput = resumeForm.querySelector('[data-registration-resume-application]');
    const tokenInput = resumeForm.querySelector('[data-registration-resume-token]');
    const resumeSubmit = resumeForm.querySelector('[data-registration-resume-submit]');
    const fragment = window.location.hash.startsWith('#')
      ? window.location.hash.slice(1)
      : '';
    const clearFragment = () => {
      const currentUrl = new URL(window.location.href);
      currentUrl.hash = '';
      window.history.replaceState({}, document.title, `${currentUrl.pathname}${currentUrl.search}`);
    };
    const decodeContinuationApplicationId = (rawToken) => {
      if (
        typeof rawToken !== 'string'
        || rawToken.length === 0
        || rawToken.length > 4096
      ) return null;
      let token;
      try {
        token = decodeURIComponent(rawToken);
      } catch {
        return null;
      }
      const parts = token.split('.');
      if (
        parts.length !== 2
        || !parts.every((part) => /^[A-Za-z0-9_-]+$/.test(part))
      ) return null;
      try {
        const base64 = parts[0].replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + ((4 - base64.length % 4) % 4), '=');
        const payload = JSON.parse(window.atob(padded));
        const applicationId = payload?.applicationId;
        return typeof applicationId === 'string'
          && /^[A-Za-z0-9_-]{1,128}$/.test(applicationId)
          ? { applicationId, token }
          : null;
      } catch {
        return null;
      }
    };

    if (fragment) {
      const continuation = decodeContinuationApplicationId(fragment);
      // Remove the bearer before any form submission or subsequent navigation.
      clearFragment();
      if (
        !continuation
        || !applicationInput
        || !tokenInput
      ) {
        if (resumeStatus) resumeStatus.textContent = 'This continuation link is not valid. Request a fresh link from Fernain.';
      } else {
        applicationInput.value = continuation.applicationId;
        tokenInput.value = continuation.token;
        if (resumeStatus) resumeStatus.textContent = 'Your application is ready to continue in this browser.';
        if (resumeSubmit) resumeSubmit.hidden = false;
      }
    } else if (resumeStatus) {
      resumeStatus.textContent = 'Open this page from a current continuation link to continue.';
    }
  }

  const form = document.querySelector('[data-registration-wizard]');
  if (form) {
    const steps = [...form.querySelectorAll('[data-registration-step]')];
    const progressItems = [...form.querySelectorAll('[data-registration-progress-item]')];
    const status = form.querySelector('[data-registration-status]');
    let currentStep = 0;

    const reviewValue = (name) => {
      if (name === 'requestedArchetype') {
        return form.querySelector('[data-selected-archetype] strong')?.textContent?.trim() || '';
      }
      const fields = [...form.elements].filter((field) => field.name === name);
      const selected = fields.find((field) => field.type !== 'radio' || field.checked);
      if (!selected) return '';
      if (selected.type === 'radio') {
        return selected.closest('label')?.querySelector('strong')?.textContent?.trim() || selected.value;
      }
      return selected.value.trim();
    };

    const updateReview = () => {
      form.querySelectorAll('[data-registration-review]').forEach((node) => {
        const primaryName = node.dataset.registrationReview;
        const fallbackName = node.dataset.registrationReviewFallback;
        const value = reviewValue(primaryName) || (fallbackName ? reviewValue(fallbackName) : '');
        node.textContent = value || 'Not yet provided';
      });
    };

    const validateCurrentStep = () => {
      const fields = [...steps[currentStep].querySelectorAll('input, select, textarea')]
        .filter((field) => !field.disabled);
      for (const field of fields) {
        if (field.checkValidity()) continue;
        field.reportValidity();
        field.focus();
        return false;
      }
      return true;
    };

    const showStep = (nextStep, moveFocus = true) => {
      currentStep = Math.max(0, Math.min(nextStep, steps.length - 1));
      steps.forEach((step, index) => {
        step.hidden = index !== currentStep;
      });
      progressItems.forEach((item, index) => {
        item.classList.toggle('is-complete', index < currentStep);
        item.classList.toggle('is-current', index === currentStep);
        if (index === currentStep) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
      const label = steps[currentStep].dataset.stepLabel;
      if (status) status.textContent = `Step ${currentStep + 1} of ${steps.length}: ${label}`;
      updateReview();
      if (moveFocus) {
        steps[currentStep].querySelector('legend')?.focus({ preventScroll: true });
        steps[currentStep].scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    if (steps.length > 1) {
      form.dataset.registrationEnhanced = 'true';
      form.querySelectorAll('[data-registration-next]').forEach((button) => {
        button.addEventListener('click', () => {
          if (validateCurrentStep()) showStep(currentStep + 1);
        });
      });
      form.querySelectorAll('[data-registration-back]').forEach((button) => {
        button.addEventListener('click', () => showStep(currentStep - 1));
      });
      form.addEventListener('input', updateReview);
      form.addEventListener('change', updateReview);
      form.addEventListener('submit', updateReview);
      showStep(0, false);
    }
  }

  const demoRequestForm = document.querySelector('[data-demo-request-form]');
  if (demoRequestForm) {
    const requestId = demoRequestForm.querySelector('[data-demo-request-id]');
    const status = demoRequestForm.querySelector('[data-demo-request-status]');
    const submit = demoRequestForm.querySelector('[data-demo-request-submit]');
    let submitted = demoRequestForm.getAttribute('data-demo-request-complete') === 'true';
    const identifierPattern = /^[A-Za-z0-9][A-Za-z0-9._:-]{0,159}$/;
    const uncertainSubmissionMessage = 'We could not confirm whether your demo request was accepted. Do not submit it again.';
    const isIdentifier = (value) => typeof value === 'string' && identifierPattern.test(value);

    const finalizeUncertainSubmission = (reference) => {
      submitted = true;
      demoRequestForm.setAttribute('data-demo-request-complete', 'true');
      if (submit) submit.disabled = true;
      if (status) {
        status.hidden = false;
        status.textContent = `${uncertainSubmissionMessage}${isIdentifier(reference) ? ` Reference: ${reference}` : ''}`;
      }
    };

    if (requestId && !requestId.value) {
      requestId.value = typeof globalThis.crypto?.randomUUID === 'function'
        ? globalThis.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    }

    demoRequestForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitted || demoRequestForm.getAttribute('aria-busy') === 'true') return;
      if (!demoRequestForm.checkValidity()) {
        demoRequestForm.reportValidity();
        return;
      }

      demoRequestForm.setAttribute('aria-busy', 'true');
      if (submit) submit.disabled = true;
      if (status) {
        status.hidden = false;
        status.textContent = 'Submitting your demo request…';
      }

      try {
        const payload = new URLSearchParams();
        new FormData(demoRequestForm).forEach((value, name) => {
          if (typeof value === 'string') payload.append(name, value);
        });
        const response = await fetch(demoRequestForm.getAttribute('action') || window.location.pathname, {
          method: 'POST',
          body: payload,
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            'Idempotency-Key': requestId?.value || '',
          },
        });
        const result = await response.json().catch(() => null);
        if (!response.ok || result?.ok !== true || typeof result?.acceptedMessageId !== 'string') {
          const canResubmit = result?.canResubmit === true;
          const retryRequestId = result?.retryable === true && isIdentifier(result?.retryRequestId)
            ? result.retryRequestId
            : null;
          if (canResubmit) {
            if (retryRequestId && requestId) requestId.value = retryRequestId;
            if (status) {
              status.hidden = false;
              status.textContent = typeof result?.error === 'string'
                ? result.error
                : 'The demo request could not be submitted.';
            }
            if (submit) submit.disabled = false;
            return;
          }
          finalizeUncertainSubmission(result?.reference ?? requestId?.value);
          return;
        }
        submitted = true;
        demoRequestForm.setAttribute('data-demo-request-complete', 'true');
        if (status) {
          status.hidden = false;
          status.textContent = `Your demo request was accepted. Reference: ${result.acceptedMessageId}`;
        }
      } catch {
        finalizeUncertainSubmission(requestId?.value);
      } finally {
        demoRequestForm.removeAttribute('aria-busy');
      }
    });
  }

  const recordAudit = () => {
    const root = document.documentElement;
    root.dataset.horizontalOverflow = String(root.scrollWidth > window.innerWidth + 1);
    root.dataset.imagesLoaded = String([...document.images].every((image) => image.complete && image.naturalWidth > 0));
  };
  window.addEventListener('load', recordAudit, { once: true });
  window.addEventListener('resize', recordAudit);
})();
